import createPersistedState from 'vuex-persistedstate';

export default ({ store }) => {
	createPersistedState({
		paths: [ 'userLogin.ageGate', 'userLogin.popupMgm', 'userLogin.userRegistration', 'userLogin.timerPopup', 'userLogin.errorMessages.messageLogOut', 'userLogin.popupQuestionsIqosScienceLater' ],
		storage: window.sessionStorage,
	})(store);
};
